import NotFoundPage from '@brands/Dashboard/NotFoundPage/NotFoundPage';
import { selectAuth } from '@brands/store/selectors/auth';
import { AuthState } from '@brands/store/slices/authSlice';
import React from 'react';

import MedicalInformationSummaryAdminView from '../../../../default/Dashboard/MedicalHistory/MedicalInformationSummary/MedicalInformationSummary';
import { useAppSelector } from '../../../hooks/useReduxHook';
import { UserRoleName } from '../../../services/identity/types/UserProfile';
import MedicalInformationSummary from './MedicalInformationSummary';

const MedicalInformationSummaryValidation: React.FC = () => {
  let component: JSX.Element;
  const user: AuthState = useAppSelector(selectAuth);

  switch (user.userInfo?.role.name) {
    case UserRoleName.Patient:
      component = <MedicalInformationSummary />;
      break;
    case UserRoleName.OrganizationAdmin:
    case UserRoleName.SuperAdmin:
    case UserRoleName.Admin:
    case UserRoleName.Collector:
      component = <MedicalInformationSummaryAdminView />;
      break;
    default:
      component = <NotFoundPage />;
      break;
  }

  return <div>{component}</div>;
};

export default MedicalInformationSummaryValidation;
